import { AccountDateRange } from 'Types/account';

export const defaultAccountDateRanges = [
	AccountDateRange.ALL,
	AccountDateRange.TODAY,
	AccountDateRange.YESTERDAY,
	AccountDateRange.LAST_7_DAYS,
	AccountDateRange.LAST_30_DAYS,
];
